// components/layout/StandardLayout.jsx
import React from 'react';
import Navbar from './Navbar'; // adjust path if needed


const StandardLayout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-grow container mx-auto px-4 py-8 pt-2">
      {children}
    </main>
    {/* <Footer /> */}
  </div>
);

export default StandardLayout;
